import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment-timezone';
import { osName, osVersion, browserName, browserVersion } from 'react-device-detect';

import { hideAuthLoader } from 'actions/Auth';
import { setLoader, submitErrorDetails } from 'actions/App';

import packageJson from '../../../package.json';
import ButtonContained from 'components/ButtonContained';
import TextInput from 'components/TextInput';

const ErrorNew = ({ errorDetails, dismissError }) => {
  const [userInput, setUserInput] = useState('');
  const dispatch = useDispatch();
  const intl = useIntl();
  const authUser = useSelector((state) => state.auth.authUser);

  const errorSubmit = () => {
    dispatch(
      submitErrorDetails(
        {
          type: errorDetails.type,
          code: errorDetails.code,
          subcode: errorDetails.subcode,
          timeStamp: moment().utc().format(),
          version: packageJson.version ? packageJson.version : null,
          OS: osName && osVersion ? `${osName} ${osVersion}` : null,
          environment: browserName && browserVersion ? `${browserName} ${browserVersion}` : null,
          userUUID: authUser ? authUser.uuid : null,
          siteUUID: localStorage.getItem('nse_login_data')
            ? JSON.parse(localStorage.getItem('nse_login_data')).siteUUID
            : null,
          claimsCompanyUUID: localStorage.getItem('nse_login_data')
            ? JSON.parse(localStorage.getItem('nse_login_data')).companyUUID
            : null,
          url: window.location ? window.location.href : null,
          endpoint: errorDetails.endpoint,
          jsonSent: errorDetails.jsonSent,
          jsonReceived: errorDetails.jsonReceived,
          userNotes: userInput
        },
        {
          message: intl.formatMessage({ id: 'notifications.success.errorSubmission' })
        }
      )
    );
    dispatch(setLoader(false));
    dispatch(hideAuthLoader());
  };

  const viewKnowledgeBase = () => {
    window.location = 'https://www.janusintl.com/knowledge';
  };

  const hasErrorID = errorDetails && errorDetails.errorID && errorDetails.errorID !== '';

  return (
    <div className="flex flex-col gap-6 w-full px-10">
      {/* Error Description Section */}
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <span className="tw-paragraph-md font-semibold text-gray-800">
              {intl.formatMessage({ id: 'comp.table.header.description' })}:
          </span>
          <span className="tw-paragraph-md text-gray-600">
              {errorDetails && errorDetails.description}
          </span>
        </div>

        <div className="flex flex-col gap-1">
          <span className="tw-paragraph-md font-semibold text-gray-800">
            {intl.formatMessage({ id: 'pages.troubleshoot.Types' })}:
          </span>
          <span className="tw-paragraph-md text-gray-600">
            {errorDetails && errorDetails.code == 90
              ? intl.formatMessage({ id: 'form.login.visitKnowledgeBaseLater' })
              : errorDetails && errorDetails.troubleshoot && errorDetails.troubleshoot}
          </span>
        </div>

          {/* User Input Section - Only show if no errorID */}
          {!hasErrorID && (
            <div className="mt-2">
              <TextInput
                id="Error-Modal-User-Input"
                dataCy="Error-Modal-User-Input"
                placeholder={intl.formatMessage({ id: 'comp.table.header.tellUsMore' })}
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
              />
            </div>
          )}

          {/* Error Code Display */}
          <div className="mt-2">
            {hasErrorID ? (
              <div className="flex flex-col gap-1">
                <span className="tw-paragraph-sm font-semibold text-gray-800">
                  Smart Entry Error Code:
                </span>
                <span className="tw-paragraph-sm text-gray-600">
                  {errorDetails.errorID}{' '}
                  <span className="text-gray-500">
                      ({errorDetails.type}-{errorDetails.code}.{errorDetails.subcode})
                  </span>
                </span>
              </div>
            ) : (
              errorDetails && (
                <span className="tw-paragraph-sm text-gray-500">
                  Smart Entry Error Code: {errorDetails.type}-{errorDetails.code}.
                  {errorDetails.subcode}
                </span>
              )
            )}
          </div>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end gap-3 pt-4">
        {errorDetails && errorDetails.code == 90 && (
          <ButtonContained
            id="Error-Modal-View-Knowledgebase-Button"
            dataCy="Error-Modal-View-Knowledgebase-Button"
            text={intl.formatMessage({ id: 'form.login.knowledgeBase' })}
            type="medium"
            onClick={viewKnowledgeBase}
          />
        )}

        {errorDetails && errorDetails.code && errorDetails.code !== 131 && (
          <ButtonContained
            id="Error-Modal-Go-Back-Button"
            dataCy="Error-Modal-Go-Back-Button"
            text={intl.formatMessage({ id: 'comp.button.goBack' })}
            type="medium"
            onClick={() => dismissError()}
          />
        )}

        {!hasErrorID ? (
          <ButtonContained
            id="Error-Modal-Submit-Error-Button"
            dataCy="Error-Modal-Submit-Error-Button"
            text={intl.formatMessage({ id: 'comp.button.submitError' })}
            type="medium"
            onClick={errorSubmit}
          />
        ) : (
          <ButtonContained
            id="Error-Modal-Dismiss-Error-Button"
            dataCy="Error-Modal-Dismiss-Error-Button"
            text={intl.formatMessage({ id: 'pages.users.dismissTraining' })}
            type="medium"
            onClick={() => dismissError(true)}
          />
        )}
      </div>
    </div>
  );
};

export default ErrorNew;